import React from "react";
import "./App.css";
import SimpleNavBar from "./components/layout/SimpleNavBar";
import SimpleMap from "./components/SimpleMap";
import { Col, Container, Row } from "react-bootstrap";
import Cards from "./components/Cards";
import BusinessHoursTable from "./components/BusinessHoursTable";

function App() {
  return (
    <header className="App-header">
      <SimpleNavBar className="w-100" />
      <Container
        fluid
        className="App w-100 align-self-start"
        style={{ paddingTop: 100 }}
      >
        <Row>
          {/* <Col xs={3} style={{ backgroundColor: "#AAA" }}> */}
          <Col md={12} lg={4}>
            <Row>
              <Col>
                <SimpleMap />
              </Col>
            </Row>
            <Row className="" style={{ fontSize: 16 }}>
              <Col>
                <p>
                  We are located at&nbsp;
                  <a
                    // href="https://goo.gl/maps/offFy6u2yneLb1mp8"
                    href="https://maps.app.goo.gl/axaeq32UWxoQbmrR7"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    227 E Main St Whitewater, WI
                  </a>
                </p>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <h2>OUR HOURS</h2>
                <hr />
                <BusinessHoursTable />
              </Col>
            </Row>
            <br />
          </Col>
          {/* <Col xs={9} style={{ backgroundColor: "#888" }}> */}
          <Col md={12} lg={8}>
            <h2>SERVICES</h2>
            <hr />
            <Cards />
          </Col>
        </Row>
        <br />
        <br />
      </Container>
    </header>
  );
}

export default App;
